<template>
    <resources-base-table
        :modelService="modelService"
        :headers="headers"
        :inputs="inputs"
        :items="universidadesRecomendadas"
        :creating="creating"
    >
        <template v-slot:form="{ localEditedItem }">
            <v-select
                v-model="localEditedItem.plataformaId"
                :items="plataformas"
                item-text="plataforma"
                item-value="id"
                label="Plataforma"
            ></v-select>
            <v-select
                v-model="localEditedItem.universidadId"
                :items="universidades"
                item-text="universidad"
                item-value="id"
                label="Universidades"
            ></v-select>
        </template>
    </resources-base-table>
</template>

<script>
import {
    UniversidadRecomendadaService,
    PlataformaService,
    UniversidadesService
} from "../../../services/carreras-api.service"
export default {
    data: () => ({
        modelService: UniversidadRecomendadaService,
        inputs: [
            {
                sortable: true,
                text: "Universidad",
                value: "universidadId"
            },
            {
                text: "Plataforma",
                value: "plataformaId",
                sortable: false
            }
        ],
        headers: [
            {
                sortable: false,
                text: "ID",
                value: "id"
            },
            {
                sortable: false,
                text: "Plataforma",
                value: "plataforma.plataforma"
            },
            {
                sortable: false,
                text: "Universidad",
                value: "universidad.universidad"
            },
            { text: "Acciones", value: "action", sortable: false }
        ],
        selectedItems: { plataformaId: "", universidadId: "" },
        plataformas: [],
        universidades: [],
        uniRecomendadas: []
    }),
    props: ["universidadesRecomendadas", "creating"],
    created() {
        PlataformaService.where().then(plat => {
            this.plataformas = plat
        })
        UniversidadesService.where().then(unis => {
            this.universidades = unis
        })
    }
}
</script>
